import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type InvoiceEntryLaunchState = {
    carrierId: string;
    invoiceNum: string;
    invIdx?: number | null;
    invRev?: number | null;
};

const baseSessionState = {
    carrierId: '',
    invoiceNum: '',
    invIdx: null,
    invRev: null,
} as InvoiceEntryLaunchState;

const slice = createSlice({
    name: 'invoiceEntryLaunch',
    initialState: baseSessionState,
    reducers: {
        setLaunchInfo: (
            state,
            action: PayloadAction<InvoiceEntryLaunchState>
        ) => {
            state.carrierId = action.payload.carrierId;
            state.invoiceNum = action.payload.invoiceNum;
            state.invIdx = action.payload.invIdx ?? null;
            state.invRev = action.payload.invRev ?? null;
        },
        clearLaunchInfo: (state) => {
            state.carrierId = '';
            state.invoiceNum = '';
            state.invIdx = null;
            state.invRev = null;
        },
    },
});

export const {setLaunchInfo, clearLaunchInfo} = slice.actions;

export default slice.reducer;
